import { Grid, Typography, Button, CircularProgress, Dialog, DialogContent } from "@material-ui/core";
import { Casino, Create, LocalBar, LocalPizza, ViewCarousel } from "@material-ui/icons";
import { useEffect, useRef, useState } from "react";

const SLOT_OPTIONS = [
  { icon: <ViewCarousel fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/>, color: '#FF682C', prize: 'Card Deck', weight: 0.001 },
  { icon: <LocalBar fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/>, color: '#28C4FC', prize: 'Beer Koozie', weight: 0.30 },
  { icon: <Create fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/>, color: '#28C4FC', prize: 'Pen', weight: 0.30 },
  { icon: <LocalPizza fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/>, color: '#142E3E', prize: 'Pizza Cutter', weight: 0.10 },
  { icon: <Casino fontSize="inherit" style={{display: "inline-block", verticalAlign: "middle"}}/>, color: '#142E3E', prize: 'Dice Set', weight: 0.10 },
];

export default function SlotMachine({ isOpen, onClose, isMultiSpin = false }) {
  const [spinning, setSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [reels, setReels] = useState([0, 0, 0]);
  const [winner, setWinner] = useState(false);
  const spinRef = useRef(null);
  const timeoutRef = useRef(null);

  const getWeightedRandom = () => {
    if (!SLOT_OPTIONS?.length) return 0;

    const totalWeight = SLOT_OPTIONS.reduce((a, b) => a + b.weight, 0);

    let random = Math.random() * totalWeight;

    for (let i = 0; i < SLOT_OPTIONS.length; i++) {
      random -= SLOT_OPTIONS[i].weight;

      if (random <= 0) return i;
    }

    return SLOT_OPTIONS.length - 1;
  };

  const handleSpin = () => {
    if (spinning) return;
    setSpinning(true);
    setWinner(false);

    const spinDuration = 3500;
    spinRef.current = setInterval(() => {
      setReels([Math.floor(Math.random() * SLOT_OPTIONS.length), Math.floor(Math.random() * SLOT_OPTIONS.length), Math.floor(Math.random() * SLOT_OPTIONS.length)]);
    }, 50);

    timeoutRef.current = setTimeout(() => {
      clearInterval(spinRef.current);
      const winningIndex = getWeightedRandom();
      setReels([winningIndex, winningIndex, winningIndex]);
      setWinner(true);
      setSpinning(false);

      if (!isMultiSpin) setHasSpun(true);
    }, spinDuration);
  };

  useEffect(() => {
    if (!isOpen || hasSpun) return;

    handleSpin();
  }, [hasSpun, isOpen]);

  useEffect(() => {
    if (!winner) return;

    return () => {
      clearTimeout(timeoutRef.current);
    }
  }, [winner])

  useEffect(() => {
    return () => {
      clearInterval(spinRef.current);
      clearTimeout(timeoutRef.current);
    }
  }, [])

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth style={{textAlign: "center"}}>
      <DialogContent style={{padding: "20px 0px 40px"}}>
        <Typography variant="h3" style={{color: "#142E3E"}}><b>Spin to Win!</b></Typography>
        <Grid container spacing={0} justifyContent="center" style={{margin: "50px 0px 30px", gap: "20px"}}>
          {reels.map((reel, idx) => (
            <Grid item xs="auto" key={idx}>
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  border: "2px solid #142E3E",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f0f0f0",
                  overflow: "hidden"
                }}
              >
                <Typography 
                  variant="h3" 
                  style={{color: SLOT_OPTIONS[reel].color ?? 'initial'}}
                >
                  {SLOT_OPTIONS[reel].icon}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
        {winner && !spinning ? ( 
            <>
              <Typography variant="h4" style={{color: "#28C4FC", marginBottom: "10px", fontWeight: "bold"}}>🎉 YOU WON! 🎉</Typography>
              <Typography variant="body1" style={{fontWeight: "bold", color: '#142E3E'}}>Prize: {SLOT_OPTIONS[reels[0]]?.prize ? SLOT_OPTIONS[reels[0]]?.prize : ''}</Typography>
              { isMultiSpin ? (
                  <Button 
                    variant="contained" 
                    size="small" 
                    style={{marginTop: "20px"}} 
                    onClick={() => {
                      onClose(); 
                      setWinner(false);
                    }}
                  >
                    Close
                  </Button>
                ) : (
                  <Button 
                    variant="contained" 
                    size="small" 
                    style={{marginTop: "50px"}} 
                    onClick={() => {
                      onClose(); 
                      setWinner(false);
                    }}
                  >
                    Return to Product Page
                  </Button>
                )
              }
            </>
          ) : (
            <Typography variant="h6" style={{fontWeight: "bold"}}>
              <CircularProgress size={15} style={{marginRight: "5px"}}/> Spinning...
            </Typography>
          )
        }
      </DialogContent>
    </Dialog>
  );
}